module.exports = __webpack_public_path__ + "img/grid-listing-active.84d70aa1.svg";